<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('documento', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
      </SearchCollapse>
      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paIds', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('regionalId', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>
      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>
      <SearchCollapse title="Geral">
        <NxSelectQuadro
          @update:value="handleSelectUpdate('quadroId', parseInt($event))"
        />
        <!-- ORIGEM AND SITUACAO ARE NOT MADE -->
        <NxSelectSituacao
          @update:value="handleSelectUpdate('situacao', $event)"
        />
        <NxInputDateRange
          label="Período de Referência:"
          @update:InitialValue="
            handleInputDateUpdate('periodoReferenciaInicial', $event, false)
          "
          @update:FinalValue="
            handleInputDateUpdate('periodoReferenciaFinal', $event, false)
          "
        />
        <NxSelectEvento
          @update:value="handleSelectUpdate('eventoId', $event)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputMoneyRange,
  NxInputName,
  NxInputNumberRange
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectEvento,
  NxSelectFuncionario,
  NxSelectOrigem,
  NxSelectPA,
  NxSelectProduto,
  NxSelectQuadro,
  NxSelectRegional,
  NxSelectResponsavelGrupo,
  NxSelectSituacao,
  NxSelectTipoEvento
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import riskTypes from '@/enums/enumRiskTypes.js'

export default {
  name: 'SidebarQuadro',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectResponsavelGrupo,
    NxSelectProduto,
    NxSelectQuadro,
    NxSelectOrigem,
    NxSelectSituacao,
    NxInputDocument,
    NxInputName,
    NxInputMoneyRange,
    NxInputNumberRange,
    NxInputDateRange,
    NxSelectEvento,
    NxSelectTipoEvento
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        documento: null,
        paIds: null,
        regionalId: null,
        gerenteId: null,
        responsavelId: null,
        grupoResponsavelId: null,
        quadroId: null,
        situacao: null,
        periodoReferenciaInicial: null,
        periodoReferenciaFinal: null,
        tipoEventoId: null,
        eventoId: null,
        registroEventoInicial: null,
        registroEventoFinal: null,
        registroTipoEventoInicial: null,
        registroTipoEventoFinal: null,
        numProtocolo: null,
        returnTipoEventoCRM: true
      },
      riskTypes: riskTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    debugLog () {
      console.log(this.form)
    },
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      console.log(this.form.nome)
      this.form[dataPropName] = encodeURIComponent(value)
      console.log(this.form.nome)
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      console.log(typeof selectedValue)
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/followup/crmActions/search/SidebarRelatorioCrmActions.vue